import styled from 'styled-components';

export const Wrapper = styled.div``;
export const PageTitle = styled.div`
  margin: ${({ theme }) => theme.spacing.x4} 0px;
`;

export const FilightsTableDefult = styled.div`
  text-align: center;
  width: 100px;
`;

export const FilightsTierTable = styled(FilightsTableDefult)``;

export const FilightsStatusTable = styled(FilightsTableDefult)``;

// ---------------head-action----------------
export const FilightsHeadAction = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    width: 100%;
    justify-content: flex-end;
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 100%;
    justify-content: center;
  }
`;

export const FilightsHeadActionButtons = styled.div`
  margin-inline-start: ${({ theme }) => theme.spacing.x4};
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin-inline-start: 0px;
  }
`;

export const InputParent = styled.div`
  width: 50%;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    width: 100%;
  }
`;

export const containerTitleAndInput = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;

export const containerTitle = styled.div``;

///////////////////////////////////////////////

// ----------------head----------------------

export const MerchantHead = styled.div`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    flex-direction: column;
  }
`;
export const TitlePageContntainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    margin-bottom: ${({ theme }) => theme.spacing.x2};
  }
`;

export const MerchantHeadCount = styled.div`
  font-size: ${({ theme }) => theme.fs.xxs};
  margin-inline: ${({ theme }) => theme.spacing.x1};
  margin-top: 2px;
`;
export const MerchantHeadActive = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    width: 100%;
    justify-content: flex-end;
  }
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    justify-content: center;
  }
`;
export const MerchantHeadActiveButtons = styled.div`
  margin-inline-start: ${({ theme }) => theme.spacing.x4};
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    margin-inline-start: 0px;
  }
`;
//-----------------CreditCard------------------------
export const CreditCardWrraper = styled.div`
  margin: 2rem 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const RowHead = styled.div`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    flex-direction: column;
    justify-content: flex-end;
  }
`;
export const RowCreateCart = styled.div`
  padding: 1rem 0rem !important;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;

export const ffpInput = styled.div`
  width: 100% !important;
  margin-right: 1rem !important;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    margin-right: 0 !important;
  }
`;

export const Delivery = styled.div`
  width: 100%;
`;

export const ButtonWrapperSend = styled.div`
  width: 100%;
`;
